import { Observable } from 'rxjs';
import { ViewerService } from '../../../services/viewer.service';
import { Operation, OperationType } from './operation';

export class DeleteDmOperation implements Operation {

    name: string;
    operationType: OperationType = OperationType.DELETE_DM;
    stepId: string;
    private viewerService: ViewerService;
    private appeazUrl: string;
    private readonly dynamicModificationIds: Array<number>;
    private idAppeaz: number;
    private appeazRole: string;
    private readonly isPhotoImportOperation: boolean;

    constructor(viewerService: ViewerService, name: string, idAppeaz: number, appeazUrl: string, appeazRole: string,
        stepId: string, dynamicModificationIds: Array<number>, isPhotoImportOperation: boolean) {
        this.name = name;
        this.viewerService = viewerService;
        this.appeazUrl = appeazUrl;
        this.stepId = stepId;
        this.dynamicModificationIds = dynamicModificationIds;
        this.idAppeaz = idAppeaz;
        this.appeazRole = appeazRole;
        this.isPhotoImportOperation = isPhotoImportOperation;
    }

    getDynamicModificationId(): Array<number> {
        return this.dynamicModificationIds;
    }

    getName(): string {
        return this.name;
    }

    execute(): Observable<number> {
        return this.viewerService.deleteDynamicModificationPreviewById(this.appeazUrl, this.stepId, this.dynamicModificationIds, this.idAppeaz, this.appeazRole);
    }

    getOperationType(): OperationType {
        return this.operationType;
    }

    getStepId(): string {
        return this.stepId;
    }

    isImportPhotoOperation(): boolean {
        return this.isPhotoImportOperation;
    }
}
